module.exports = __webpack_public_path__ + "static/media/user.1772b6c1.svg";